const endpoint = (process.env.NODE_ENV === 'developmentx')
  ? 'http://localhost:3000/liff'
  : 'https://api.artemishosp.inncom.cloud/liff';

const socket = (process.env.NODE_ENV === 'developmentx')
  ? 'ws://localhost:3001'
  : 'wss://socket.artemishosp.inncom.cloud';

export default {
  auth: `${endpoint}/auth`,
  membership: `${endpoint}/membership`,
  schedules: `${endpoint}/schedules`,
  appointments: `${endpoint}/appointments`,
  feedbacks: `${endpoint}/feedbacks`,
  visitorRegistrations: `${endpoint}/visitor-registrations`,
  chatPictures: `${endpoint}/chat-pictures`,
  chatSocket: socket,
};
